module.exports = __webpack_public_path__ + "static/img/info-template3-en.9126c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info-template3-en.png
// module id = 7+Dl
// module chunks = 1